import { Component, ViewEncapsulation } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-root',
    template: '<div sumeTheme><router-outlet></router-outlet></div>',
    encapsulation: ViewEncapsulation.None,
})
export class AppComponent {
    isdev = !environment.production;

    constructor() {}
}
